import React, { useState, useEffect, PureComponent, useRef, useMemo, useCallback, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';
import config from '../config';
import Sidebar from '../SideMenu';

const SegregatedMandates = () => {
  const [status, setStatus] = useState(false);
  const [marketContent, setMarketContent] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMarketContent();
  }, []);

  const fetchMarketContent = async () => {
    try {
      setError(null);
      const response = await fetch(config.apiPath + '/market_contentapi');
      
      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        // Try to read the response text to see what we actually got
        const responseText = await response.text();
        console.error('Expected JSON but got:', responseText.substring(0, 200));
        throw new Error(`Expected JSON response but got ${contentType}. Response preview: ${responseText.substring(0, 100)}...`);
      }
      
      const data = await response.json();
      
      // Find the content for Segregated Mandates (id: 49)
      const segregatedContent = data.find(item => item.id === 49);
      
      if (segregatedContent) {
        setMarketContent(segregatedContent.content);
        setStatus(true);
      } else {
        setError('No content found for Segregated Mandates');
        console.warn('No content found for Segregated Mandates (id: 49)');
      }
    } catch (error) {
      console.error('Error fetching market content:', error);
      setError(`Failed to load content: ${error.message}`);
    }
  };

  return (
    <Fragment>
      {error ? (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="alert alert-danger" role="alert">
                <h4 className="alert-heading">Error Loading Content</h4>
                <p>{error}</p>
                <hr/>
                <p className="mb-0">Please try refreshing the page or contact support if the problem persists.</p>
              </div>
            </div>
          </div>
        </div>
      ) : status ? (
        <section className="main-box">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-4">
                <Sidebar StateSession={{StateSession: [], "url": "SegregatedMandates", "group": "Fixed Income"}} />
              </div>
              <div className="col-lg-8 col-md-8 col-sm-8 offset-md-1">
                <div className="Section__SectionContent-sc-1iot0f7-2" dangerouslySetInnerHTML={{ __html: marketContent }}>
                </div>
                
                {/* <div className="Section__SectionContent-sc-1iot0f7-2">
                  <h3>Our products</h3><br/>
                  <p>
                    <NavLink to="/markets/EpicNextGenUcitsFundRoute" className="navlink a decoration-none">
                      EPIC - Next Generation Bond Fund UI (UCITS)<span className="fa fa-angle-right"></span>
                    </NavLink><br/>
                    
                    {localStorage.getItem('session') ? (
                      <NavLink to="/markets/EpicNextGenPCC" className="navlink a">
                        EPIC - Next Generation Bond Fund (PCC)<span className="fa fa-angle-right"></span>
                      </NavLink>
                    ) : (
                      <a href={config.apiPath + "/login_user"} className="navlink a">
                        EPIC - Next Generation Bond Fund (PCC)<span className="fa fa-angle-right"></span>
                      </a>
                    )}
                    <br/>
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </section>
      ) : (
        <div className="center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default SegregatedMandates;